import createHistory from "history/createBrowserHistory";
import React from "react";
import { render } from "react-dom";
import ModalDialog from "@zendesk/knowledge-components/lib/ModalDialog";
import { ThemeProvider } from "@zendeskgarden/react-theming";
import t from "@zendesk/client-i18n-tools";

const elm = document.createElement("div");
document.body.appendChild(elm);

const history = createHistory({
  basename: "/knowledge/verification/",
  getUserConfirmation: (message, callback) => {
    const onComplete = choice => {
      callback(choice);
      render(null, elm);
    };

    render(
      <ThemeProvider rtl={t.dir === "rtl"}>
        <ModalDialog
          testId="discardChangesModal"
          visible
          body={message}
          onSubmit={() => onComplete(true)}
          onCancel={() => onComplete(false)}
        />
      </ThemeProvider>,
      elm
    );
  },
});

export default history;



// WEBPACK FOOTER //
// ./src/utils/history.js